import request from "../../request.js"
import qs from "qs";

// 上传文件接口
export  function uploadInterviewAudio(data) {
	return request({
		url: "/iv-audio/uploadInterviewAudio",
		method: "POST",
		data
	})
}
// 上传文件接口-阿里云
export  function uploadAliyunFile(data) {
	return request({
		url: "/aliyun-file/uploadAliyunFile",
		method: "POST",
		data
	})
}
// 获取操作日志
export  function getSysLogList(data) {
	return request({
		url: "/sys-log/getSysLogList",
		method: "POST",
		data
	})
}
// 新增用户
export  function addPkqAdmin(data) {
	return request({
		url: "/pkq-admin/addPkqAdmin",
		method: "POST",
		data
	})
}
// 获取用户列表
export  function getPkqAdminList(data) {
	return request({
		url: "/pkq-admin/getPkqAdminList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑用户
export  function updatePkqAdmin(data) {
	return request({
		url: "/pkq-admin/updatePkqAdmin",
		method: "POST",
		data
	})
}
// 登录
export  function doLogin(data) {
	return request({
		url: "/pkq-admin/doLogin",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除用户
export  function deletePkqAdmin(data) {
	return request({
		url: "/pkq-admin/deletePkqAdmin",
		method: "POST",
		data
	})
}
// 修改用户密码
export  function updatePkqAdminPw(data) {
	return request({
		url: "/pkq-admin/updatePkqAdminPw",
		method: "POST",
		data
	})
}


//新增题目分类
export  function addIvqTopicClass(data) {
	return request({
		url: "/ivq-topic-class/addIvqTopicClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除题目分类
export  function deleteIvqTopicClass(data) {
	return request({
		url: "/ivq-topic-class/deleteIvqTopicClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取题目分类
export  function getIvqTopicClassList(data) {
	return request({
		url: "/ivq-topic-class/getIvqTopicClassList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑题目分类
export  function updateIvqTopicClass(data) {
	return request({
		url: "/ivq-topic-class/updateIvqTopicClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//题目类型列表
export  function getPkqTopicTypeList(data) {
	return request({
		url: "/pkq-topic-type/getPkqTopicTypeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增试题
export  function addPkqTopic(data) {
	return request({
		url: "/pkq-topic/addPkqTopic",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除试题
export  function deletePkqTopic(data) {
	return request({
		url: "/pkq-topic/deletePkqTopic",
		method: "POST",
		data:qs.stringify(data)
	})
}
//试题列表
export  function getPkqTopicList(data) {
	return request({
		url: "/pkq-topic/getPkqTopicList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑试题
export  function updatePkqTopic(data) {
	return request({
		url: "/pkq-topic/updatePkqTopic",
		method: "POST",
		data:qs.stringify(data)
	})
}

//批量上传试题
export  function uploadPkqTopic(data) {
	return request({
		url: "/pkq-topic/uploadPkqTopic",
		method: "POST",
		data
	})
}
//试卷列表
export  function getPkqPaperList(data) {
	return request({
		url: "/pkq-paper/getPkqPaperList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//试卷详情
export  function getPkqPaperDetails(data) {
	return request({
		url: "/pkq-paper/getPkqPaperDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//答题结果列表
export  function getPkqPaperRecordList(data) {
	return request({
		url: "/pkq-paper-record/getPkqPaperRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//答题结果详情
export  function getPkqPaperRecordDetails(data) {
	return request({
		url: "/pkq-paper-record/getPkqPaperRecordDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增pk网格
export  function addPkqUser(data) {
	return request({
		url: "/pkq-user/addPkqUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除pk网格
export  function deletePkqUser(data) {
	return request({
		url: "/pkq-user/deletePkqUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表pk网格
export  function getPkqUserList(data) {
	return request({
		url: "/pkq-user/getPkqUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑pk网格
export  function updatePkqUser(data) {
	return request({
		url: "/pkq-user/updatePkqUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增pk时间段
export  function addPkqDurationRule(data) {
	return request({
		url: "/pkq-duration-rule/addPkqDurationRule",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除pk时间段
export  function deletePkqDurationRule(data) {
	return request({
		url: "/pkq-duration-rule/deletePkqDurationRule",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取pk时间段
export  function getPkqDurationRuleList(data) {
	return request({
		url: "/pkq-duration-rule/getPkqDurationRuleList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑pk时间段
export  function updatePkqDurationRule(data) {
	return request({
		url: "/pkq-duration-rule/updatePkqDurationRule",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量导入网格用户
export  function uploadPkqUser(data) {
	return request({
		url: "/pkq-user/uploadPkqUser",
		method: "POST",
		data
	})
}
//新增案例推荐
export  function addPkqCaseVideo(data) {
	return request({
		url: "/pkq-case-video/addPkqCaseVideo",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除案例推荐
export  function deletePkqCaseVideo(data) {
	return request({
		url: "/pkq-case-video/deletePkqCaseVideo",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表案例推荐
export  function getPkqCaseVideoList(data) {
	return request({
		url: "/pkq-case-video/getPkqCaseVideoList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑案例推荐
export  function updatePkqCaseVideo(data) {
	return request({
		url: "/pkq-case-video/updatePkqCaseVideo",
		method: "POST",
		data:qs.stringify(data)
	})
}
//下架-案例推荐
export  function updatePkqCaseVideoDown(data) {
	return request({
		url: "/pkq-case-video/updatePkqCaseVideoDown",
		method: "POST",
		data:qs.stringify(data)
	})
}
//上架-案例推荐
export  function updatePkqCaseVideoUp(data) {
	return request({
		url: "/pkq-case-video/updatePkqCaseVideoUp",
		method: "POST",
		data:qs.stringify(data)
	})
}
//统计-案例推荐
export  function getPkqCaseVideoLookList(data) {
	return request({
		url: "/pkq-case-video-look/getPkqCaseVideoLookList",
		method: "POST",
		data:qs.stringify(data)
	})
}